import { render, staticRenderFns } from "./claim-update-request-component.vue?vue&type=template&id=60162e9d&"
import script from "./claim-update-request-component.vue?vue&type=script&lang=ts&"
export * from "./claim-update-request-component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports